module.exports={
    authorization: {
        all: '全部尺寸',
        search:'搜索',
        import:'导 入',
        download:'下 载',
        // scan:'扫描标签',
        // authorizationAll:'授权所有',
        table:{
        	index:'序号',
        	mac:'MAC地址',
        	screenSize:'屏幕尺寸(")',
        	battery:'电量(%)',
        	lastupdate:'最后广播时间',
        	// operator:'操作',
        	// authorization:'授权'
        },
        dialogAuthor:{ //授权弹框
            dialogTitle:'授 权',
            dialogMsg:'确定授权{mac}吗?'
        },
        dialogAuthorAll:{ //授权选中的所有标签弹框
            dialogTitle:'授 权',
            dialogMsg:'确定授权选中的标签吗?',
            hint:'请先选择要授权的标签！'
        },
        upload:{
            success:'导入标签成功,成功{success}个,重复失败{fail}个！',
            fail:'导入标签失败！',
            msg:'上传文件只能是Excel表格'
        },
        permission:{
            addLabel:'新增标签'
        },
        queryAuthor:{
            fail:'查询标签失败！'
        },
        cancel:'取 消',
        sure:'确 定',
        hint:'提 示'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/authorization.js